import Keycloak, { KeycloakConfig } from "keycloak-js";

const clientId: string = process.env.REACT_APP_CLIENT_ID || "";
const realm: string = process.env.REACT_APP_CLIENT_REALM || "";
const authUrl: string = process.env.REACT_APP_API_KC_URL || "";

const keycloakConfig: KeycloakConfig = {
  clientId: clientId,
  realm: realm,
  url: authUrl,
};

const keycloak = new Keycloak(keycloakConfig);

export default keycloak;
